import styled from 'styled-components';

const FormContainer = styled.form`
	margin-top: 9.5rem;
	max-width: 53rem;
	width: 100%;
`;

export default FormContainer;
